import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import initDataDog from '../../utils/dataDogRum';

if (process.env.LOCAL !== 'true') {
  initDataDog();
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('missing root element');
createRoot(rootElement).render((<App />) as any);
